import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Modal,
  Grid,
  IconButton,
  Select,
  MenuItem,
  useTheme,
  Typography,
} from "@mui/material";
import ZoomImageModal from "../../../common/userFeedback/modals/ZoomImageModal"
import ScrollImageModal from "../../../common/userFeedback/modals/ScrollImageModal"
import { BASE_IMAGE_URL } from "../../../../config/apiConfig";

function ClickableScrollImage({ sxImg={}, image=null, numImages=0, garmentUUID=null}) {
  const [columns, setColumns] = useState(5);
  const [openModal, setOpenModal] = useState(false);
  const [images, setImages] = useState(null);
  const imageRef = useRef(null);
  const { palette } = useTheme();

  const handleRightClick = (event) => {
    event.preventDefault(); // Prevent default context menu
    event.stopPropagation(); // Prevents the event from bubbling up to the Box

    setOpenModal(true);
  };

  const handleClose = (event) => {
    event.stopPropagation(); // Prevents the event from bubbling up to the Box
    setOpenModal(false);
  };

  useEffect(() => {
    if (!numImages)
    {
      //TODOWP get numImages
      numImages = 1
      
      console.log(`params.row.numImages: ${numImages} ${garmentUUID}`)
    }

    let imageUrls = [];
    for (let i = 1; i <= numImages; i++) {
      let imageUrl = `${BASE_IMAGE_URL}${garmentUUID}-${i}.jpg`;
      console.log(imageUrl);
      imageUrls.push(imageUrl);
    }
    setImages(imageUrls);
  }, [numImages, BASE_IMAGE_URL, garmentUUID])

  return (
    <Box
      sx={{
        justifyContent: "flex-start",
        alignItems: "center",
        display: "flex",
        height: "100%",
        position: "relative",
      }}
      onContextMenu={handleRightClick} // Add this line to ensure right-click is captured
    >
      {(images && images.length > 0) || (image !== null && image !== undefined)
      ? <Box
        component="img"
        src={image ?? images[0]}
        alt={`image`}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          cursor: "context-menu",
          marginLeft: -2,
          padding: 1,
          ...sxImg
        }} // Indicate right-click is available
      />
      : <Typography variant="h4" sx={{color: palette.primary[300]}}>No image.</Typography>}

      <ScrollImageModal handleClose={handleClose} openModal={openModal} images={images}  disabled={image === null || image === undefined}/>
    </Box>
  );
}

export default ClickableScrollImage;
